export default "__VITE_ASSET__b039c9e0__"